module.exports = __webpack_public_path__ + "img/ally-rogo-white3.9641cca0.png";